/** @format */
import pRetry from 'p-retry';

/**
 * Back-off retry the given async function until it resolves.
 * uses P-retry internally
 * @param {() => unknown} fn - The function we want to retry
 * @param {number} [retries=10] - The maximum number of retries
 * @param {number} [timeout] - A timeout in miliseconds
 */
export async function retry(
    fn: () => unknown,
    retries = 10,
    timeout?: number
): Promise<any> {
    let isTimedOut: boolean = false;
    let timeoutFn;
    let returnedValue: any;

    if (timeout) {
        timeoutFn = setTimeout(() => {
            isTimedOut = true;
        }, timeout);
    }

    try {
        returnedValue = await pRetry(fn, {
            onFailedAttempt: () => {
                if (isTimedOut) {
                    throw new Error();
                }
            },
            retries,
        });
    } catch (error) {
        // noop swallow the error
    }

    if (timeoutFn) {
        clearTimeout(timeoutFn);
    }

    return returnedValue;
}
